"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var general_1 = require("../../lib/general");
var icons_1 = __importDefault(require("../../theme/icons"));
require("./style.scss");
function Table(props) {
    var _a = (0, react_i18next_1.useTranslation)(), i18n = _a.i18n, t = _a.t, header = ["category", "icon", "sorting_order", "edit", "delete"];
    return (react_1.default.createElement("div", { style: {
            borderRadius: "10px",
            border: "1px solid #b9b9b9",
        } },
        react_1.default.createElement("table", { id: "rwd-table" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, header.map(function (l) { return (react_1.default.createElement("th", { key: l }, t(l))); }))),
            react_1.default.createElement("tbody", null, props.list.length > 0
                ? props.list.map(function (l, i) {
                    // const url_name = isJsonWithAvailableLang(
                    //   l.category_icon_web,
                    //   i18n.language,
                    //   t,
                    // );
                    return (react_1.default.createElement("tr", { key: l.id },
                        react_1.default.createElement("td", null, (0, general_1.isJsonWithAvailableLang)(l.name, i18n.language, t)),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("a", { onClick: function () {
                                    var _a;
                                    return window.open("".concat((_a = l === null || l === void 0 ? void 0 : l.category_icon_web) !== null && _a !== void 0 ? _a : l.icon_web), "_blank");
                                } },
                                react_1.default.createElement("img", { className: "category-image", 
                                    // src={l.category_icon}
                                    src: "".concat(l.category_icon_web) }))),
                        react_1.default.createElement("td", null, l.sorting),
                        react_1.default.createElement("td", { onClick: function () { return props.onEditClick(l, i); } },
                            react_1.default.createElement(icons_1.default, { className: "icon_black", height: 30, name: "edit", width: 30 })),
                        react_1.default.createElement("td", { onClick: function () { return props.onDeleteClick(l, i); } },
                            react_1.default.createElement(icons_1.default, { className: "icon_black", height: 30, name: "delete", width: 30 }))));
                })
                : null))));
}
exports.default = Table;
